import {MILISECONDS_PER_DAY} from "@/constants/appConstant";

export const setlocalStorageValue = (name, value, days) => {
    const expires = new Date().getTime() + days * MILISECONDS_PER_DAY;
    const data = {
        value: value,
        expiryTime: expires
    }
    localStorage.setItem(name, JSON.stringify(data));
}

export const getLocalStorageValue = (name) => {
    let result = null;
    if (typeof window !== "undefined" && window.localStorage) {
        result = localStorage.getItem(name);
        result = result ? JSON.parse(result) : null;
    }
    return result;
}